import React from "react";
import PropTypes from "prop-types";
import { Box } from "@shopify/polaris";

const spacingMap = {
  1: "8px",
  2: "16px",
  3: "24px",
  4: "32px",
  5: "40px",
};

export default function Stack({
  children,
  flexDirection = "row",
  flexWrap = "wrap",
  spacing = 1,
  justifyContent = "flex-start",
  alignItems = "stretch",
  height,
  width,
  onClick,
  style,
  className = "",
  innerRef,
}) {
  const stackStyle = {
    display: "flex",
    flexDirection,
    flexWrap,
    gap: spacingMap[spacing] || spacing,
    justifyContent,
    alignItems,
    height: height || "auto",
    width: width || "auto",
    ...style,
  };

  return (
    <Box ref={innerRef} className={className} style={stackStyle} onClick={onClick}>
      {children}
    </Box>
  );
}

Stack.propTypes = {
  children: PropTypes.node,
  flexDirection: PropTypes.oneOf(["row", "column"]),
  flexWrap: PropTypes.oneOf(["wrap", "nowrap", "wrap-reverse"]),
  spacing: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  justifyContent: PropTypes.oneOf([
    "flex-start",
    "flex-end",
    "center",
    "space-between",
    "space-around",
    "space-evenly",
  ]),
  alignItems: PropTypes.oneOf(["flex-start", "flex-end", "center", "stretch", "baseline"]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  style: PropTypes.object,
};
